export const mountWords = (phraseName, phrase) => {
  const splitWords = phrase.split(' ');
  const words = splitWords.map((word, index) => {
    return {
      // id: `${chapterIndex}-${paragraphIndex}-${index}-${word}`,
      id: `words-${phraseName}-${index}-${word}`,
      text: word,
      isValid: false,
      // highlight: false,
      // isBlurring: false,
    }
  });

  return words;
}

// export const getHighlightWord = (words) => {
//   let highlightIndex = 0;
  
//   words?.find((word, index) => {
//     if(!word.isValid) {
//       highlightIndex = index;
//       return word;
//     }
//   });
  
//   const newWords = words?.map(word => ({ ...word, highlight: false }))
//   newWords[highlightIndex].highlight = true;

//   return newWords
// }

// export const removeHighlightWord = (words) => {
//   return words?.map(word => ({
//     ...word,
//     highlight: false
//   }))
// }